module.exports = __webpack_public_path__ + "img/ywx.08e07ff2.png";